var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{attrs:{"cx":"12","cy":"12","r":"2.088","stroke-width":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }